import { createFileRoute } from "@tanstack/react-router";

import { TripAnalyzerRoute } from "../../containers/TripAnalyzerRoute";

export const Route = createFileRoute("/_layout-nosidebar/trip-analyzer")({
    component: TripAnalyzerPage,
});

function TripAnalyzerPage() {
    return <TripAnalyzerRoute />;
}
